'use strict';

/** @type {import('./abs')} */
module.exports = Math.floor;



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-intrinsics/floor.js
// module id = GJov
// module chunks = 0